/* lua.js generated code 0.3.0 */
var PaymentGuideManager = require("activity/IosPaymentGuide/PaymentGuideManager")
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
var SnsProxy = require("clover/sns/SnsProxy")
let ShareUtil = require("clover/utils/ShareUtil")
var CashNotEnoughPanel = xClass("CashNotEnoughPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/shop_shop_short.csb")
})
let preload_res = ['packed/MarketPanelShort.pack']
// let extra_plist = "cocos/market_panel.plist"
/**
 * @param   
 */
CashNotEnoughPanel.show = function (confirm, cancel, extra) {
    function callback() {
        CashNotEnoughPanel.create(confirm, cancel, extra);
    }
    function onFail() {
        Toast.make(getText("error.tip.timeout"))
    }
    // preload_res = clone(CashNotEnoughPreloadConfig)
    // if (!cc.loader.getRes(getRealResourceName(extra_plist))) {
    //     preload_res.push(extra_plist)
    // }
    // let preload_list = buildResList(preload_res)
    preloadWithLoading(preload_res, callback, onFail)
}
CashNotEnoughPanel.prototype.ctor = function (confirmCallback, cancelCallback, extra) {
    var self = this
    self.onConfirm = confirmCallback
    self.extra = extra || {}
    self.onCancel = cancelCallback
    self.bannerAdName = BannerAdPanel.kCashNotEnough
    self.gridAdName = GridAdPanel.kCashNotEnough;
    self.marketManager = MarketManagerNew.getInstance()
    self.init()
    cc.log("CashNotEnoughPanel extra",extra)
    if (!MetaManager.isSupportCash() && !SnsProxy.getInstance().allowAd() && !SnsProxy.getInstance().allowShare()) {
        Toast.make(getText("error.tip.760330"), null, () => {
            self.onCancel && self.onCancel.call(null)
        })
        return;
    }
    let uid_new =  UserManager.getInstance().uid
    self.session = self.extra.session || `${uid_new}_${Localhost.timeInSec()}`
    
    self.pf = self.extra.pf || "other"
    self.marketManager.dcMarketNormal("coin_lack_show",null,{
        session: self.session,
        pf: self.pf
    })
    self.popup()

}
CashNotEnoughPanel.prototype.init = function () {
    var self = this;
    BasePanel.prototype.init.call(self)
    let closeBtn = UIButton.create(self.getChildByName("com_close"));
    PushBounceAnim.create(closeBtn)
    closeBtn.on(UIButtonEvent.Click, ()=>{
        if (self.isBusy){
            return
        }
        self.isBusy = true;
        self.marketManager.dcMarketNormal("coin_lack_click",null,{
            session: self.session,
            pf: self.pf,
            type: "cancel"
        })
        if (self.onCancel) {
            self.onCancel()
        }
        this.onClose()
    })

    let goShopBtn = UIButton.create(self.getChildByName("btn_refresh"));
    PushBounceAnim.create(goShopBtn)
    goShopBtn.on(UIButtonEvent.Click, ()=>{
        this.goToShop()
    })

    let goWelfareCenterBtn = UIButton.create(self.getChildByName("btn_ad"));
    PushBounceAnim.create(goWelfareCenterBtn)
    goWelfareCenterBtn.on(UIButtonEvent.Click, ()=>{
        this.goToWelfareCenter()
    })
    self.getChildByName("label_main").ignoreContentAdaptWithSize(true)
    self.getChildByName("label_main").setString(getText("shop.tip.addcoin"))

    if (IslandTreasureLogic.getInstance().canShowBanner()){
        self.createIslandTreasureBanner()
    }
   
}
CashNotEnoughPanel.prototype.goToShop = function () {
    let self = this;
    if (self.isBusy){
        return
    }
    self.isBusy = true;
    self.marketManager.dcMarketNormal("coin_lack_click",null,{
        session: self.session,
        pf: self.pf,
        type: "shop"
    })
    self.onClose()
    
    self.setGameSceneContinueCheck(false)
    if (self.extra.cashGoodsEntry){
        MarketManager.getInstance().setCashGoodsEntry(self.extra.cashGoodsEntry)
    }
    MarketManager.getInstance().showMarketPanel(null, (panel)=>{
        if (self.onConfirm) {
            self.onConfirm(panel)
            // DCAssist.userTrack("stage_start", "click_buy_happycoins");
        }
        panel.on(BasePanelEvent.Close, ()=> MarketManager.getInstance().clearCashGoodsEntry())
    }, ()=>{
        if (self.onCancel) {
            self.onCancel()
        }
        self.isBusy = false
    })

  
}
// 前往福利中心
CashNotEnoughPanel.prototype.goToWelfareCenter = function () {
    let self = this
    if (self.isBusy){
        return
    }
    self.isBusy = true;
    self.marketManager.dcMarketNormal("coin_lack_click",null,{
        session: self.session,
        pf: self.pf,
        type: "welfare_center"
    })
    self.onClose()

    const WelfareCenterLogic = require("activity/WelfareCenter/WelfareCenterLogic")
    WelfareCenterLogic.enterType = "lack_coin"
    WelfareCenterLogic.openPanel((panel) => {
        if(panel) {
            if (self.onConfirm) {
                self.onConfirm(panel,true)
            }
        }else{
            if (self.onCancel) {
                self.onCancel()
            }
        }
    })
}
CashNotEnoughPanel.prototype.setGameSceneContinueCheck = function (f) {
    var scene = cc.Director.getInstance().getRunningScene();
    if (scene.name == "GameScene"){
        scene.needContinueCheck = f;
    }
}

// CashNotEnoughPanel.prototype.popup = function () {
//     var self = this
//     var targetScale = self.getScale()
//     self.setScale(0)
//     var time = 7 / 30
//     PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
//     // var dH = display.height-GamePlayConfig_Design_Height;
//     // var targetPos = cc.pAdd(cc.p(self.getPosition()), cc.p(62, 850 + dH/2 - 100));
//     var targetPos = cc.p(display.width / 2, display.height / 2)
//     var pos_O = cc.p(display.width / 2, display.height / 2)
//     var startPoint = cc.pMul(cc.pSub(targetPos, pos_O), 0.23)
//     self.setScale(0.23)
//     self.setPosition(cc.p(pos_O.x + startPoint.x, pos_O.y + startPoint.y))
//     self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
//     //  打开BannerAd
//     self.tryShowBannerAd();
//     return self
// }

/**
 * 创建海岛礼包面板
 */
CashNotEnoughPanel.prototype.createIslandTreasureBanner = function () {
    var self = this

    preloadWithLoading([
        // `cocos/islandtreasure_gift.csb`,
        `cocos/islandtreasure.plist`,
        `cocos/islandtreasure_islandtreasure_gift.csb`,
        // `cocos/bear.atlas`,
        // `cocos/bear.txt`,
        // `cocos/reward.atlas`,
        // `cocos/reward.txt`,
        //     // "font/zzgftongxin.fnt",
        // "font/zzgftongxin_40_aquastroke.fnt",
        "font/zzgftongxin_40_greenstroke.fnt",
        "font/berlinsansfb_40_lightbrownstroke.fnt",
        "font/zzgftongxin_70_brownstroke.fnt",
        "font/berlinsansfb_100_redstroke.fnt",
        "font/zzgftongxin_guide.fnt",
        
        
    ], function () {
        let rewardItems =  IslandTreasureData.getInstance().getBuyRewards()
        let banner = cc.CSLoader.createNode("cocos/islandtreasure_islandtreasure_gift.csb")
        // banner.getChildByName("desc").setString(getText("battlepass.start.text3"))
        banner.getChildByName("endgift_btn_left").setVisible(false)
        banner.getChildByName("endgift_btn_right").setVisible(false)
        banner.getChildByName("label_giftname").x += 15
        banner.getChildByName("bg_gold_only").getChildByName("icon1").addChild(UIItemBuilder.createProp(GamePropIds.kCash, null, 1)[0])
        banner.getChildByName("bg_gold_only").getChildByName("label_iconnum1").setString("x" + rewardItems[1].num)
        // banner.getChildByName("bg_gold_only").getChildByName("icon1").x += 75
        // banner.getChildByName("bg_gold_only").getChildByName("label_iconnum1").x += 75

        banner.getChildByName("bg_gold_only").getChildByName("icon2").addChild(UIItemBuilder.createProp(GamePropIds.kCash, null, 1)[0])
        banner.getChildByName("bg_gold_only").getChildByName("label_goldnum").setString("x" + IslandTreasureData.getInstance().getAllRewards())


        banner.getChildByName("btn").getChildByName("txt").setString("￥" + IslandTreasureData.getInstance().getPrice())

        TTUtil.addTTIcon( banner.getChildByName("btn").getChildByName("txt"),IslandTreasureData.getInstance().getPrice())
        banner.getChildByName("bg_5").setVisible(false)
        banner.getChildByName("bg_gold").setVisible(false)
        banner.getChildByName("endgift_bg_light").setVisible(false)
        
        var vSize = cc.Director.getInstance().getVisibleSize()
        // banner
        
        let node = cc.Node.create()
        // node.setContentSize()
        node.setPosition(cc.p(0, (-display.height/2 - 150)/2));
    
        node.setContentSize(banner.getChildByName("endgift_bg1").getContentSize())
        // banner.setPosition(0, -460)
        node.addChild(banner)
        self.addChild(node)
        node.setScale(0.98)
        
        // self.addChild(banner)
    
        
        let session = null;
        quickBuildUIButton(node, ()=>{
            IslandTreasureLogic.getInstance().buy(function(){
                banner.setVisible(false)
                ActivityGetRewardsPanel.show({
                    type:1,
                    // extraHint: extraNode,
                    // add_model: "ship_building_stage",// test 为获取道具的category
                    rewardList: rewardItems,
                    tobagAni: true, //碎片类型不进背包
                    // title:`${rewardPlistName}/reward_title02.png`,
                    closeCb:()=>{
                    
                    }
                })
            }, function(){},null,{session,entry: "lack_coin"})
        })
        session = DCAssist.dc4ShowCashGoods(ModuleName.ISLAND_TREASURE, "lack_coin", [IslandTreasureData.getInstance().getGoodsId()])
    })

    self.notCheckBanner = true
    
    // let node = cc.node
    // const AIPkgReviveView = require("activity/AIPackage/AIPkgReviveView");
    // self.aiPkgNode = AIPkgReviveView.create();
    // self.addChild(self.aiPkgNode)
    // self.aiPkgNode.popup();
    // self.aiPkgNode.on(AIPkgReviveView.Events.BuyPackages, function(){
    //     if(self.nodeExist && !self.isClosed) {
    //         self.refreshAddStepPanel();
    //     }
    // });
}

CashNotEnoughPanel.prototype.cleanup = function () {
    BasePanel.prototype.cleanup.call(this)
    // cc.warn("TODO: unload res list")
    // let preload_list = buildResList(preload_res)
    unloadResList(preload_res)
    // let index = preload_res.indexOf(extra_plist)
    // if (index !== -1) {
    //     preload_res.splice(index,1)
    // }
}


module.exports = CashNotEnoughPanel
